import Chip from "@mui/material/Chip";

export const getEventoStatus = (evento) => {
  if (evento.enviado) return { label: "Enviado", color: "success" };
  if (evento.aprovado) return { label: "Aprovado", color: "primary" };
  return { label: "Aguardando aprovação", color: "warning" };
};

const EventoStatusChip = ({ evento, ...rest }) => {
  const { label, color } = getEventoStatus(evento);
  return <Chip size="small" variant="outlined" label={label} color={color} {...rest} />;
};

export default EventoStatusChip;
